<template>
  <panel :title="$t(`${module.from.identifier}.label`) + ' > ' + $t(`${module.to.identifier}.label`)">
    <div class="l-row vertical-center">
      <div class="l-col-4@md l-col-offset-1">
        <img :src="module.from.logo" class="logo center" alt="">
      </div>
      <div class="l-col-2@md u-textCenter">
        <i class="i-arrow icon-arrow-right center"></i>
      </div>
      <div class="l-col-4@md">
        <img :src="module.to.logo" class="logo center" alt="">
      </div>
    </div>

    <footer class="c-card__footer u-textLeft">
      <button @click="presetAction(preset)" class="btn btn--smart btn--sm btn--info" v-for="preset in module.presets" :key="preset">
        {{ $t(`${preset.type}.label`) }}
      </button>
    </footer>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import ModuleLogo from '@/components/template/ModuleLogo'

  export default {
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      presetAction (preset) {
        return this.$router.push(`presets/${preset.from.type}/${preset.from.identifier}/${preset.to.type}/${preset.to.identifier}/${preset.type}`)
      }
    },
    components: {
      Panel,
      ModuleLogo
    }
  }
</script>

<style lang="sass" scoped>
  .logo
    max-width: 100%
    max-height: 80px
    height: auto

  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 80px

  button
    margin: 13px 10px 10px 0
</style>



// WEBPACK FOOTER //
// Card.vue?3eb9afd8